import styled from "styled-components";
import { colors, spacing } from "../../styles/_var";
import TextWithIcon from "../TextWithIcon";


export const RequestSentLabel = styled(TextWithIcon)`
  background: ${colors.lightyellow};
  padding: 5px ${spacing.xs};
  border-radius: 10px;
`